// import { JwtPayload, verify, decode as decodeToken } from "jsonwebtoken";
import { useMemo } from "react";

export const decode = <T>(token: string) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64)) as T;
};

/**
 * @todo this hook no longer uses jsonwebtoken because bonfire complains that
 * there is no `process` var. need to look into this.
 */
export const useJwt = <T>(token: string | null) => {
  return useMemo(() => {
    if (token == null) return { data: undefined, error: undefined };

    try {
      const data = decode<T>(token);
      return { data, error: false };
    } catch (e) {
      return { data: undefined, error: true };
    }
  }, [token]);
};
